import { VERSION } from "@/config/config";
import $localStorage from "@/utils/localStorage";
// 版本号
const Versions = "xxVersions";
// 外卖还是堂食的字段名
const StoreType = "xxStoreType";
// 是否扫码点餐
const IsDesk = "xxIsDesk";
// 选中的经纬度
const CurrentPoint = "xxCurrentPoint";
// 初始化时间值
const InitDateTime = "xxInitDateTime";
// 选中时间的字段名
const SelectedDateTime = "xxSelectDateTime";
// 用户选中的地址的字段名
const MemberSelectedAddress = "xxMemberSelectedAddress";
// 门店最近地址
const ShopNearestAddress = "xxShopNearestAddress";
// 用户选中的门店的基本信息
const SelectedShopOptions = "xxSelectedShopOptions";
// 当前门店详情
const SelectedStoreDetail = "xxSelectedStoreDetail";
// 用户选中的优惠券
const OrderConfirmSelectedCoupon = "xxOrderConfirmSelectedCoupon";
// 订单确认缓存字段
const OrderConfirmCache = "xxOrderConfirmCache";
// 订单持久化缓存字段
const OrderConfirmPersistentCache = "xxOrderConfirmPersistentCache";
// 查看评论的商品id
const CommentMealId = "xxCommentMealId";
// 商务楼选中字段
const MemberSelectedBuilding = "xxMemberSelectedBuilding";
// 门店购物车列表
const StoreMealObject = "xxStoreMealObj";
// 订单确认页面是否选择自提
const OrderIsTake = "xxOrderIsTake";
// 堂食引导绑定手机
const CanteenDailyShowBindPhone = "xxCanteenDailyShowBindPhone";
// 门店显示自提信息
const StoreShowTakeMessageBox = "xxStoreShowTakeMessageBox";
//生活垃圾管理条例
const ManagementRegulations = "xxmanagementRegulations";
//管理条例
const ManagementRegulationsText = "亲爱的顾客，为响应《上海市生活垃圾管理条例》，助力美好生活，7月1日起，外卖不主动提供餐具。选择餐品时不要忘记还有餐具选项哦。";

let versions = $localStorage.get(Versions);
// 如果当前版本不等于用户缓存版本号
if (versions != VERSION) {
	// 设置新版本号
	$localStorage.set(Versions, VERSION);
	// 删除所有缓存信息
	$localStorage.del(StoreType);
	$localStorage.del(IsDesk);
	$localStorage.del(CurrentPoint);
	$localStorage.del(InitDateTime);
	$localStorage.del(SelectedDateTime);
	$localStorage.del(MemberSelectedAddress);
	$localStorage.del(ShopNearestAddress);
	$localStorage.del(SelectedShopOptions);
	$localStorage.del(SelectedStoreDetail);
	$localStorage.del(OrderConfirmSelectedCoupon);
	$localStorage.del(OrderConfirmCache);
	$localStorage.del(OrderConfirmPersistentCache);
	$localStorage.del(CommentMealId);
	$localStorage.del(MemberSelectedBuilding);
	$localStorage.del(StoreMealObject);
	$localStorage.del(OrderIsTake);
	$localStorage.del(ManagementRegulations);
	$localStorage.del(CanteenDailyShowBindPhone);
	$localStorage.del(StoreShowTakeMessageBox);
}

// 弹出框图片
import * as MessageBoxImageType from "@/constants/imageType";
// 订单状态
import * as OrderStatusMap from "@/constants/orderStatus";
// 订单状态对应文案
import * as OrderStatusTextMap from "@/constants/orderStatusText";
// 支付图片
import * as PayImageType from "@/constants/payImageType";

export {
	StoreType,
	IsDesk,
	CurrentPoint,
	InitDateTime,
	SelectedDateTime,
	MemberSelectedAddress,
	ShopNearestAddress,
	SelectedShopOptions,
	SelectedStoreDetail,
	CommentMealId,
	OrderConfirmSelectedCoupon,
	OrderConfirmCache,
	OrderConfirmPersistentCache,
	MemberSelectedBuilding,
	StoreMealObject,
	OrderIsTake,
	ManagementRegulations,
	ManagementRegulationsText,
	CanteenDailyShowBindPhone,
	StoreShowTakeMessageBox,
	MessageBoxImageType,
	OrderStatusMap,
	OrderStatusTextMap,
	PayImageType,
};
